export const state = {
	cabinets: null
}



// WEBPACK FOOTER //
// ./src/store/modules/Cabinets/state.js